import { render, staticRenderFns } from "./CheckReasonModal.vue?vue&type=template&id=565c8f80"
import script from "./CheckReasonModal.vue?vue&type=script&lang=js"
export * from "./CheckReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports